import React, {Component} from "react";
import {Helmet} from "react-helmet"

export default class TagHeaders extends Component {
	constructor(props) {
		super(props);
		this.state = {
			id: "",
			title: "",
			description: "",
			image: "",
			date: "",
			link: ""
		}
	}

	componentDidMount() {
		var data = this.props.value;
		console.log(data);
		this.setState({
			id: data.docid,
			title: data.title,
			description: data.description,
			image: (data.pictures !== "" && data.pictures !== undefined)? data.pictures : '',
			date: (data.dates !== "" && data.dates !== undefined)? data.dates : '',
			link: data.links
		});
	}

	render() {
		return (
			<Helmet>
				{this.state.title !== "" && <title>NOVAIO ACADEMY - {this.state.title.replace(/[^0-9a-zA-Z-\s]/g, '').substring(0,35)}</title>}
        		{this.state.description !== "" && <meta name="description" content={this.state.description} />}
				{this.state.link !== "" && <link rel="canonical" href={this.state.link} />}
			</Helmet>
		);
	}
}
